import type { CloseActivityTypeForm } from './typings'

export const closeActivityTypeFormActionCreator =
  (): CloseActivityTypeForm => ({ type: 'activityTypeForm/closeForm' })
